module.exports = __webpack_public_path__ + "img/skip.02805053.png";